// import { toast } from "react-toastify";

// export const Msg = ({ text }) => {
//     return (
//         <p className='text-grey'>{text}</p>
//     );
// };

// export const toaster = (myProps, toastProps) => toast(<Msg {...myProps} />, { ...toastProps });

// toaster.success = (myProps, toastProps) => toast.success(<Msg {...myProps} />, { ...toastProps, position: 'top-center', className: "border border-green-500", ...toastProps });
// toaster.error = (myProps, toastProps) => toast.error(<Msg {...myProps} />, { ...toastProps, position: 'top-center', className: "border border-red-500", ...toastProps });
// toaster.warning = (myProps, toastProps) => toast.warning(<Msg {...myProps} />, { ...toastProps, position: 'top-center', className: "border border-yellow-500", ...toastProps });
// toaster.info = (myProps, toastProps) => toast.info(<Msg {...myProps} />, { ...toastProps, position: 'top-center', className: "border border-sky-500", ...toastProps });

import { toast } from "react-toastify";

export const Msg = ({ text }) => {
    return <p className="text-grey">{text}</p>;
};

const defaultToastId = "global-toast";

export const toaster = (myProps, toastProps) => toast(<Msg {...myProps} />, { ...toastProps, toastId: defaultToastId });

toaster.success = (myProps, toastProps = {}) => toast.success(<Msg {...myProps} />, { toastId: defaultToastId, position: toastProps.position || "top-center", className: "border border-green-500", ...toastProps, });
toaster.error = (myProps, toastProps = {}) => toast.error(<Msg {...myProps} />, { toastId: defaultToastId, position: toastProps.position || "top-center", className: "border border-red-500", ...toastProps, });
toaster.warning = (myProps, toastProps = {}) => toast.warning(<Msg {...myProps} />, { toastId: defaultToastId, position: toastProps.position || "top-center", className: "border border-yellow-500", ...toastProps, });
toaster.info = (myProps, toastProps = {}) => toast.info(<Msg {...myProps} />, { toastId: defaultToastId, position: toastProps.position || "top-center", className: "border border-sky-500", ...toastProps, });